<template>
  <div>
    <b-row>
      <b-col cols="12" md="6">
        <b-form-group
          :label="$lang.gender"
          label-for="gender_id"
          :label-cols="$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.gender"
            :rules="$v.gender_selected.$params"
          />
          <selectFind
            :options="gender_options"
            v-model="$v.gender_selected.$model"
            label="text"
            :placeholder="` `"
            class="multiselect-form"
            :isValid="
              $v.gender_selected.$dirty ? !$v.gender_selected.$error : null
            "
          />

          <b-form-invalid-feedback
            :style="{ display: $v.gender_selected.$error ? 'block' : 'none' }"
            id="gender_id-feedback"
          >
            {{
              $lang.error_required | replace($lang.gender)
            }}</b-form-invalid-feedback
          >
        </b-form-group>
      </b-col>
      <b-col cols="12" md="6">
        <b-form-group :label="$lang.name" :label-cols="$config.form.labelCol">
          <requiredComponent
            slot="label"
            :label="$lang.name"
            :rules="$v.name.$params"
          />
          <b-form-input
            type="text"
            :autocomplete="$lang.name"
            v-model="$v.name.$model"
            :state="$v.name.$dirty ? !$v.name.$error : null"
          >
          </b-form-input>

          <b-form-invalid-feedback v-if="!$v.name.required" id="name-feedback">
            {{ $lang.error_required | replace($lang.name) }}
          </b-form-invalid-feedback>
          <b-form-invalid-feedback
            v-if="$v.name.required && !$v.name.maxLengh"
            id="name-feedback"
          >
            {{
              $lang.error_max | replace($lang.name, "بین 2 تا 35")
            }}</b-form-invalid-feedback
          >
        </b-form-group>
      </b-col>
      <b-col cols="12" md="6">
        <b-form-group
          :label="$lang.family"
          label-for="family"
          :label-cols="$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.family"
            :rules="$v.family.$params"
          />
          <b-form-input
            v-model="$v.family.$model"
            :state="$v.family.$dirty ? !$v.family.$error : null"
            type="text"
            :autocomplete="$lang.family"
          >
          </b-form-input>
          <b-form-invalid-feedback
            v-if="!$v.family.required"
            id="family-feedback"
          >
            {{
              $lang.error_required | replace($lang.family)
            }}</b-form-invalid-feedback
          >
          <b-form-invalid-feedback
            v-if="$v.family.required && !$v.family.maxLengh"
            id="family-feedback"
          >
            {{
              $lang.error_max | replace($lang.family, "بین 3 تا 35")
            }}</b-form-invalid-feedback
          >
        </b-form-group>
      </b-col>
      <b-col cols="12" md="6">
        <b-form-group :label="$lang.mobile" label-for="mobile" :label-cols="12">
          <requiredComponent
            slot="label"
            :label="$lang.mobile"
            :rules="$v.mobile.$params"
          />
          <b-form-input
            type="text"
            maxLength="11"
            :autocomplete="$lang.mobile"
            placeholder="مثال:09121112233 "
            :state="$v.mobile.$dirty ? !$v.mobile.$error : null"
            v-model="$v.mobile.$model"
          >
          </b-form-input>
          <b-form-invalid-feedback id="mobile-feedback"
            >{{ $lang.error_required | replace($lang.mobile) }}
          </b-form-invalid-feedback>
          <div
            class="invalid-feedback"
            v-if="!$v.mobile.minLengh | !$v.mobile.maxLengh"
          >
            {{ $lang.error_length | replace($lang.mobile, 11) }}
          </div>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="6">
        <b-form-group
          :label="$lang.city_address_home"
          :label-cols="$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.city_address_home"
            :rules="$v.location_selected.$params"
          />
          <selectAsync
            :options="location_options"
            v-model="$v.location_selected.$model"
            label="caption"
            :asyncFind="getLocation"
            :isValid="
              $v.location_selected.$dirty ? !$v.location_selected.$error : null
            "
            :loading="location_loading"
            :placeholder="` `"
          />
          <b-form-invalid-feedback
            :style="{ display: $v.location_selected.$error ? 'block' : 'none' }"
          >
            {{
              $lang.error_required | replace($lang.city_address_home)
            }}</b-form-invalid-feedback
          >
        </b-form-group>
      </b-col>
      <b-col cols="12" md="6">
        <b-form-group
          :label="$lang.zone_number"
          label-for="zone_number"
          :label-cols="$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.zone_number"
            :rules="$v.zone_number.$params"
          />
          <b-form-input
            type="text"
            :autocomplete="$lang.zone_number"
            v-model="$v.zone_number.$model"
            :state="$v.zone_number.$dirty ? !$v.zone_number.$error : null"
          >
          </b-form-input>
          <b-form-invalid-feedback id="description-feedback">
            {{ $lang.error_required | replace($lang.zone_number) }}
          </b-form-invalid-feedback>
          <b-form-invalid-feedback
            v-if="$v.zone_number.$error"
            id="name-feedback"
          >
            {{
              $lang.error_Value
                .replace("{0}", $lang.$val_biography)
                .replace("{1}", "1")
                .replace("{2}", "25")
            }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-form-group
          :label="$lang.description"
          label-for="description"
          :label-cols="12"
        >
          <requiredComponent
            slot="label"
            :label="$lang.description"
            :rules="$v.description.$params"
          />
          <b-form-textarea
            class="min-heghit"
            :state="$v.description.$dirty ? !$v.description.$error : null"
            v-model="$v.description.$model"
            type="text"
            :autocomplete="$lang.description"
            :rows="$config.form.textareaRows"
          ></b-form-textarea>
          <b-form-invalid-feedback id="description-feedback">
            {{ $lang.error_required | replace($lang.description) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" class="text-right">
        <b-button
          v-if="isAdmin(parentPermissions)"
          variant="success"
          @click="submit"
        >
          {{ $lang.submitButton }}
          <i class="fa fa-check"></i>
        </b-button>
        <b-button
          type="reset"
          class="ml-2"
          size="md"
          variant="danger"
          @click="cancel"
        >
          {{ $lang.close }}
          <i class="fa fa-ban"></i>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { renderEumOptions, isAdmin } from "@/shared/utils";
import { pathOr } from "ramda";
import {
  required,
  minLength,
  maxLength,
  numeric,
} from "vuelidate/lib/validators";

export default {
  validations: {
    mobile: {
      required,
      numeric,
      minLength: minLength(11),
      maxLength: maxLength(11),
    },
    name: {},
    family: {
      required,
    },
    gender_selected: {
      required,
    },
    zone_number: {},
    description: {},
    location_selected: {
      required,
    },
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    relation_type_id: {
      type: [String, Number],
    },
    resource: {
      type: [String, Number],
    },
    itemId: {
      type: [String, Number],
    },
    resource_id: {
      type: [String, Number],
    },
    parentPermissions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      location_options: [],
      location_loading: false,
      mobile: null,
      name: null,
      family: null,
      gender_selected: null,
      zone_number: null,
      description: null,
      location_selected: null,
    };
  },
  inject: ["locationRepository"],
  watch: {
    item(newValue) {
      if (newValue) {
        this.fetchData();
      }
    },
  },
  computed: {
    gender_options() {
      return renderEumOptions("gender");
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    isAdmin,
    cancel() {
      this.$emit("cancel");
    },
    async getLocation(query) {
      if (!query || query.length < 2) {
        return;
      }
      if (query.length > 2) {
        this.location_options = [];
      }

      try {
        this.location_loading = true;
        const url = `${this.$config.api_url}${this.$config.resources.location}?city=${query}`;
        const response = await this.$httpService.get(url);
        this.location_options = pathOr([], ["data", "data"], response);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.location_loading = false;
      }
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        this.isLoading = false;
        return;
      }
      let payload = {
        name: this.name,
        family: this.family,
        mobile: this.mobile,
        email: this.email,
        relation_type_id: this.relation_type_id,
        resource: this.resource,
        resource_id: this.resource_id,
        location_id: this.location_selected && this.location_selected.id,
        gender_id: this.gender_selected && this.gender_selected.value,
        description: this.description,
        zone_number: this.zone_number,
      };
      this.$emit("submit", payload);
    },
    fetchData() {
      if (Object.keys(this.item).length > 0) {
        this.name = pathOr(null, ["person_reference", "name"], this.item);
        this.family = pathOr(null, ["person_reference", "family"], this.item);
        this.mobile = pathOr(null, ["person_reference", "mobile"], this.item);
        this.location_selected = {
          id: pathOr(null, ["person_reference", "location", "id"], this.item),
          caption: pathOr(
            null,
            ["person_reference", "location", "full_path"],
            this.item
          ),
        };

        this.gender_selected = this.gender_options.find(
          (x) =>
            x.value ===
            pathOr(null, ["person_reference", "gender", "id"], this.item)
        );
        this.zone_number = pathOr(
          null,
          ["person_reference", "zone_number"],
          this.item
        );
        this.description = this.item.description;
      }
    },
  },
};
</script>

<style>
.min-heghit {
  min-height: 30px;
}
</style>
